module.exports = __webpack_public_path__ + "static/WS_appflows_virtual_3-8929e0a45c94c2cc0d1ea979b035013b.gif";